import { toast } from "react-toastify";
import { endpoints } from "../../configs/Settings";
import { useAxios } from "../../utils/useAxios";
import { getAuthToken } from "../auth/OAuthApplication";

export async function GetAddressByCep(postalCode: any) {
  const url = `${endpoints.ViaCep}`;

  const response = await useAxios
    .get(`${url}/${postalCode}/json`, {
      headers: {
        Accept: "*/*",
        Authorization: await getAuthToken(),
        "Content-Type": "application/json",
      },
      timeout: 20000,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("GetAddressByCep ERROR", error);
      toast.error(
        `Erro ao tentar encontrar o Cep, verifique o CEP ou tente novamente: ${error?.message}`,
      );
      return {
        error: true,
      };
    });
  if (response) return response;
}
